import moment from 'moment';
import React from 'react';
import { setActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { ToastContainer, style as toastifyStyle } from 'react-toastify';
import ResizeAware from 'react-resize-aware';
import { css } from 'glamor';
import './App.css';
import uuid from 'uuid';
import PrivateRoute from './components/session/PrivateRoute';
import Login from './components/session/Login';
import Logout from './components/session/Logout';
import Navbar from './components/navbar/Navbar';
import store from './store';
import Home from './views/Home';
import Order from './views/Order';
import ChangeOrder from './views/ChangeOrder';
import Destination from './views/Destination';
import InstallationDocument from './views/InstallationDocument';
import InstallationService from './views/InstallationService';
import WorkList from './views/WorkList';
import ServiceSite from './views/ServiceSite';
import ServiceReport from './views/ServiceReport';
import LoggedOut from './views/LoggedOut';
import LoginFailed from './views/LoginFailed';
import Deviations from './views/Deviations';

toastifyStyle({
  colorDefault: '#EBF6FF',
});

class App extends React.Component {
  componentDidMount() {
    const language = localStorage.getItem('user-language') || 'fi';
    store.dispatch(setActiveLanguage(language));
    moment.locale(language);
  }

  onNavbarResize = ({ width, height }) => {
    if (this.mainElement) {
      this.mainElement.style.paddingTop = `${height}px`;
    }
  };

  render() {
    return (
      <div>
        <ResizeAware className="App-navbar-top" onlyEvent onResize={this.onNavbarResize}>
          <Navbar />
        </ResizeAware>
        <main ref={(element) => { this.mainElement = element; }}>
          <Switch>
            <PrivateRoute exact path="/" component={Home} />

            <PrivateRoute exact path="/order" component={Order} />
            <PrivateRoute exact path="/change_order" component={ChangeOrder} />

            <PrivateRoute exact path="/destination/:destinationId/:page" component={Destination} />
            <PrivateRoute exact path="/installationdocument/:shipmentId/:installationDocumentId" component={InstallationDocument} />
            <PrivateRoute exact path="/servicesite/:destinationId/:serviceSiteId/:page" component={ServiceSite} />
            <PrivateRoute exact
                          path="/installationservice/:shipmentNumber"
                          component={InstallationService}
                          key="installationDocumentId" />
            <PrivateRoute exact
                          path="/installationservice"
                          component={InstallationService}
                          key={uuid()} />
            <PrivateRoute exact path="/servicereport" component={ServiceReport} />
            <PrivateRoute exact path="/servicereport/:reportType/:shipmentId" component={ServiceReport} />
            <PrivateRoute exact path="/worklist" component={WorkList} />
            <PrivateRoute exact path="/deviations" component={Deviations} />

            <Route exact path="/login" component={Login} />
            <Route exact path="/admin" render={() => <Login admin />} />
            <Route exact path="/logout" component={Logout} />
            <Route exact path="/logged_out" component={LoggedOut} />
            <Route exact path="/login_failed" component={LoginFailed} />

            <Route component={() => '404'} />
          </Switch>
        </main>

        <ToastContainer position="bottom-right"
                        hideProgressBar
                        toastClassName={
            css({
              color: '#394a58',
              outline: '1px solid #50B9FF',
              fontWeight: 'bold',
            })
          } />

      </div>
    );
  }
}

export default withRouter(connect(
  null,
  null,
)(App));



// WEBPACK FOOTER //
// ./src/App.js